import React, { useEffect, useState } from 'react';
import { text } from '../../../../utils/text';
import { Card } from '../../../common/Card/Card';
import { scenarioSteps, trackScenario } from '../../../../tracking';
import { Layout } from '../../../common/Layout/Layout';
import { Text, Title } from '@gjensidige/core-typography';
import { useFormContext } from '../../../../context/FormContext';
import { Illustration } from '../../../common/InputOptionIllustration/Illustration';
import { NavigationButtons } from '../../../common/NavigationButtons/NavigationButtons';
import { Redirect, useHistory } from 'react-router-dom';
import { AksjeAndelPill } from '../../../common/AksjeAndelPill/AksjeAndelPill';
import { SecondaryButton } from '@gjensidige/core-buttons';
import { Info, Modal } from '@gjensidige/core-icons';
import { RisikoNeedle } from '@gjensidige/gpf-charts';
import { Divider } from '../../../common/Divider/Divider';
import { getPorteføljeForAlleRisikoprofiler, LOGGER_ENDPOINT, putChosenProfile } from '../../../../utils/api';
import { remoteLogError } from '@gjensidige/gpf-js-utils/es6/logging/error-handler';
import { Action, Risikoprofil, RoutePath } from '../../../../utils/types';
import { ProfilInfoModal } from '../../../common/ProfilInfoModal/ProfilInfoModal';
import { getFondskategoriFordeling, getProfilEnumName } from '../../../../utils/utils';
import { percent } from '@gjensidige/gpf-js-utils/es6/text/formatting';
import trygg from '../../../../../assets/images/profil_trygg.svg';
import balansert from '../../../../../assets/images/profil_balansert.svg';
import offensiv from '../../../../../assets/images/profil_offensiv.svg';
import alderstilpasset from '../../../../../assets/images/profil_alderstilpasset.svg';
import { AnbefalingModal } from '../../../common/AnbefalingModal/AnbefalingModal';
import styles from './anbefalt-profil.module.less';
export const AnbefaltProfil = () => {
    const [{ raadgivningData, kontoopplysninger, porteføljedata, risikoanbefaling, utbetalingsdetaljer }, dispatch] = useFormContext();
    const [showProfilInfoModal, setShowProfilInfoModal] = useState(false);
    const [showAnbefalingBegrunnelseModal, setShowAnbefalingBegrunnelseModal] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const history = useHistory();
    const raadgivningRef = raadgivningData === null || raadgivningData === void 0 ? void 0 : raadgivningData.ref;
    useEffect(() => {
        trackScenario(scenarioSteps.RAADGIVNING_EGNETHET_RESULTAT);
    }, []);
    useEffect(() => {
        if (risikoanbefaling && !porteføljedata) {
            getPorteføljeForAlleRisikoprofiler(utbetalingsdetaljer.uttaksalder).then((result) => {
                if (result.isOk()) {
                    dispatch({ type: Action.SUBMIT_PORTEFØLJE_FOR_ALLE_PROFILER, porteføljedata: result.value });
                }
            });
        }
    }, [dispatch, risikoanbefaling, porteføljedata, utbetalingsdetaljer.uttaksalder]);
    if (!raadgivningRef || !risikoanbefaling) {
        return React.createElement(Redirect, { to: RoutePath.RAADGIVNING_EGNETHET });
    }
    const submit = () => {
        setSubmitting(true);
        putChosenProfile(raadgivningRef, risikoanbefaling.anbefaling.risikoprofil).then((result) => {
            if (result.isOk()) {
                dispatch({
                    type: Action.SUBMIT_VALGT_RISIKOPROFIL,
                    risikoprofil: { profile: risikoanbefaling.anbefaling.risikoprofil, isAnbefaltProfil: true },
                });
                history.push(RoutePath.RAADGIVNING_FATCA);
            }
            else if (result.isErr()) {
                setSubmitting(false);
                void remoteLogError(LOGGER_ENDPOINT, new Error(result.error.message));
            }
        });
    };
    const { aksjeandel, renteandel } = getFondskategoriFordeling(risikoanbefaling === null || risikoanbefaling === void 0 ? void 0 : risikoanbefaling.portefølje);
    return (React.createElement(Layout, { title: text.LAYOUT.START_SAVING.TITLE.no },
        React.createElement(Card, { step: 4, className: styles.card },
            React.createElement("div", { className: styles.header },
                React.createElement(Title, { tag: 'h2', size: 'h5' }, text.FORM.RAADGIVNING_EGNETHET_RESULT.ANBEFALT_PROFIL.no),
                React.createElement("div", { className: styles.profilIconRow },
                    React.createElement(Title, { tag: 'h3', size: 'h2', className: styles.profil }, getProfilEnumName(risikoanbefaling === null || risikoanbefaling === void 0 ? void 0 : risikoanbefaling.anbefaling.risikoprofil)),
                    React.createElement(Illustration, { size: 60, src: getProfilIllustrasjon(risikoanbefaling.anbefaling.risikoprofil), coloredBackground: false }))),
            React.createElement("div", null,
                React.createElement("div", { className: styles.risikoAvkastningRow },
                    React.createElement("div", { className: styles.risiko },
                        React.createElement(Text, { size: 'small' }, text.FORM.RAADGIVNING_EGNETHET_RESULT.RISIKO_NEEDLE.no),
                        React.createElement(RisikoNeedle, { risk: risikoanbefaling.portefølje.risiko, size: 'sm' })),
                    React.createElement("div", { className: styles.avkastning },
                        React.createElement(Text, { size: 'small' }, text.FORM.RAADGIVNING_EGNETHET_RESULT.AVKASTNING_HITTIL_I_ÅR.no),
                        React.createElement(Text, { size: 'p' }, percent(risikoanbefaling.portefølje.avkastningHittilIAar))),
                    React.createElement("div", { className: styles.avkastning },
                        React.createElement(Text, { size: 'small' }, text.FORM.RAADGIVNING_EGNETHET_RESULT.AVKASTNING_SISTE_5_ÅR.no),
                        React.createElement(Text, { size: 'p' }, percent(risikoanbefaling.portefølje.avkastningSisteFemAar)))),
                React.createElement(Divider, null),
                React.createElement(Text, { size: 'small' }, text.FORM.RAADGIVNING_EGNETHET_RESULT.HØY_AKSJEANDEL.no)),
            React.createElement(AksjeAndelPill, { aksjeAndel: aksjeandel, renteAndel: renteandel }),
            React.createElement("div", { className: styles.buttonGroup },
                React.createElement(SecondaryButton, { onClick: () => setShowProfilInfoModal(true), size: 'sm', icon: React.createElement(Info, { size: 20 }) }, text.FORM.RAADGIVNING_EGNETHET_RESULT.LES_MER_OM_PROFIL.no),
                (risikoanbefaling === null || risikoanbefaling === void 0 ? void 0 : risikoanbefaling.anbefaling) && (React.createElement(SecondaryButton, { onClick: () => setShowAnbefalingBegrunnelseModal(true), size: 'sm', icon: React.createElement(Modal, { size: 20 }) }, text.FORM.RAADGIVNING_EGNETHET_RESULT.BAKGRUNN_FOR_ANBEFALING.no))),
            React.createElement("div", null,
                React.createElement(NavigationButtons, { nextText: text.FORM.RAADGIVNING_EGNETHET_RESULT.VELG_ANBEFALT_PROFIL.no, onPrevious: () => history.push(RoutePath.RAADGIVNING_EGNETHET), loading: submitting, onNext: submit }),
                React.createElement("div", { className: styles.velgProfilSelv },
                    React.createElement(SecondaryButton, { size: 'sm', onClick: () => history.push(RoutePath.PROFIL) }, text.FORM.RAADGIVNING_EGNETHET_RESULT.SE_FLERE_PROFILER.no))),
            React.createElement(Text, { size: 'p' }, text.FORM.RAADGIVNING_EGNETHET_RESULT.NY_VURDERING.no)),
        React.createElement(ProfilInfoModal, { profil: risikoanbefaling.anbefaling.risikoprofil, "portef\u00F8lje": risikoanbefaling.portefølje, "form\u00E5l": kontoopplysninger.spareformål, visible: showProfilInfoModal, onClose: () => setShowProfilInfoModal(false) }),
        React.createElement(AnbefalingModal, { anbefaling: risikoanbefaling === null || risikoanbefaling === void 0 ? void 0 : risikoanbefaling.anbefaling, visible: showAnbefalingBegrunnelseModal, onClose: () => setShowAnbefalingBegrunnelseModal(false) })));
};
const getProfilIllustrasjon = (profil) => {
    switch (profil) {
        case Risikoprofil.TRYGG:
            return trygg;
        case Risikoprofil.BALANSERT:
            return balansert;
        case Risikoprofil.OFFENSIV:
            return offensiv;
        case Risikoprofil.ALDERSTILPASSET:
            return alderstilpasset;
    }
};
